<div class="snackBar">
  <div class="svg-container">
    <svg width="96" height="90" viewBox="0 0 96 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="85">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.0786133H85.1958V84.7891H0V0.0786133Z" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M71.9072 21.9423C80.1209 33.2288 86.5028 45.1061 84.9664 56.5107C83.43 67.9153 74.0345 78.9063 62.9254 82.9245C51.8162 86.9427 39.0525 83.9881 26.7024 78.6109C14.4114 73.2335 2.59316 65.4335 0.406796 55.5062C-1.83863 45.5788 5.54777 33.4651 14.2932 22.1196C23.0388 10.715 33.2025 0.0786133 43.307 0.0786133C53.4707 0.0786133 63.6345 10.715 71.9072 21.9423Z"
          fill="#193356" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.543 55.1949C59.543 55.1949 28.8325 55.5128 29.6267 55.1949L29.6215 64.6527L36.6916 57.5826H61.4368C63.3811 57.5826 64.9719 55.9918 64.9719 54.0476V32.8374C64.9719 30.893 63.3811 29.3022 61.4368 29.3022L59.543 55.1949Z"
        fill="#FCCC04" />
      <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="96" height="90">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 89.9597H95.1179V0.0786133H0V89.9597Z" fill="white" />
      </mask>
      <g mask="url(#mask1)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M43.9502 50.7011H47.4852V47.166H43.9502V50.7011ZM43.9502 43.6309H47.4852V33.0258H43.9502V43.6309ZM59.8579 27.7233H31.5776C29.6333 27.7233 28.0602 29.3141 28.0602 31.2583L28.0425 63.0737L35.1126 56.0036H59.8579C61.8022 56.0036 63.3929 54.4128 63.3929 52.4686V31.2583C63.3929 29.3141 61.8022 27.7233 59.8579 27.7233Z"
          fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.43994 18.8844L8.88263 30.8756L11.3275 28.9744L16.031 36.583L14.926 24.945L12.491 26.8383L7.43994 18.8844Z"
          fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M95.118 59.9803L88.8931 65.7849L90.9912 66.3863L88.6157 72.2252L94.78 66.7596L92.6904 66.1607L95.118 59.9803Z"
          fill="#193356" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M74.5945 1.48804L69.0311 7.91917L71.1795 8.29235L69.4437 14.3464L74.983 8.25848L72.8433 7.8868L74.5945 1.48804Z"
          fill="#193356" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.465 78.015L43.297 83.9892L45.2927 84.3358L43.6803 89.9598L48.826 84.3043L46.8383 83.959L48.465 78.015Z"
          fill="white" />
      </g>
    </svg>
  </div>
  <div class="text-container">
    <div class="title">Attention.</div>
    <div class="message">
      {{ data.message }}
    </div>
    <button mat-icon-button class="close-icon" (click)="close()">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
</div>
<div class="determinate-bar">
  <ng-container *ngIf="indeterminate">
    <mat-progress-bar class="snack-bar-radius" [ngClass]="'primary'" mode="indeterminate"> </mat-progress-bar>
  </ng-container>
  <ng-container *ngIf="!indeterminate">
    <mat-progress-bar class="snack-bar-radius" [ngClass]="'primary'" mode="determinate" [value]="countPercent"> </mat-progress-bar>
  </ng-container>
</div>
